module.exports = __webpack_public_path__ + "img/s54.0978b157.png";